<div class="container-fluid">
    <div class="row">
      <div class="square day-instruction"></div>
      <div class="ml-10">Instruction active for today</div>
      <div class="ml-10 square applied-in-ppa"></div>
      <div class="ml-10">Instruction applied in EDT</div>
    </div>
    <div class="row">
      <table id="tblInstructions" class="nj-table nj-table--hover nj-table--striped nj-cursor">
        <thead>
            <tr [style]="'background-color: #d8d8d8'">
                <th colspan="4" ></th>
                <th colspan="4" class="subDiv">Commercial</th>
                <th colspan="6" class="subDiv">Output</th>
                <th colspan="2"></th>
            </tr>
          <tr [style]="'background-color: #d8d8d8'" class="pointer">
            <th (click)="DataGridHelper.SortData('notifiedOn')">Notified On</th>
            <th (click)="DataGridHelper.SortData('units')">Unit</th>
            <th (click)="DataGridHelper.SortData('startDate')">Start Date</th>
            <th (click)="DataGridHelper.SortData('endDate')">End Date</th>
            <th (click)="DataGridHelper.SortData('fixed')">Fixed</th>
            <th (click)="DataGridHelper.SortData('amazon_commercial')">Amazon</th>
            <th (click)="DataGridHelper.SortData('google_commercial_min')">Google Min</th>
            <th (click)="DataGridHelper.SortData('google_commercial_max')">Google Max</th>
            <th (click)="DataGridHelper.SortData('amazon_commissioning')">Amazon Commissioning</th>
            <th (click)="DataGridHelper.SortData('amazon_contracted')">Amazon Contracted</th>
            <th (click)="DataGridHelper.SortData('google_commissioning')">Google Commissioning</th>
            <th (click)="DataGridHelper.SortData('google_contracted')">Google Contracted</th>
            <th (click)="DataGridHelper.SortData('engie_commissioning')">Engie Commissioning</th>
            <th (click)="DataGridHelper.SortData('engie_contracted')">Engie Contracted</th>
            <th (click)="DataGridHelper.SortData('status')">Status</th>
            <th>Actions</th>
            
          </tr>
        </thead>
        <tbody>
          @for(instruction of DataGridHelper.CurrentPageData; track instruction.instructionId; let i = $index) {
          <tr [class]="GetClass(instruction.startDate, instruction.endDate, instruction.isAppliedInPPA)">
            <td>{{DateFormatHelper.GetDisplayDateOnly(instruction.notifiedOn)}}</td>
            <td>{{instruction.units}}</td>
            <td>{{DateFormatHelper.GetDisplayDateOnly(instruction.startDate)}}</td>
            <td>{{instruction.endDate == null? "" : DateFormatHelper.GetDisplayDateOnly(instruction.endDate)}}</td>
            <td>{{instruction.fixed }}</td>
            <td>{{instruction.amazon_commercial}}</td>
            <td>{{instruction.google_commercial_min}}</td>
            <td>{{instruction.google_commercial_max}}</td>
            <td>{{instruction.amazon_commissioning}}</td>
            <td>{{instruction.amazon_contracted}}</td>
            <td>{{instruction.google_commissioning}}</td>
            <td>{{instruction.google_contracted}}</td>
            <td>{{instruction.engie_commissioning}}</td>
            <td>{{instruction.engie_contracted}}</td>
            <td>{{instruction.status}}</td>
            <td>
              <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="ViewInstruction(instruction.instructionId)">
                View
              </nj-button>
              @if(UserData.HasMorayWestAccess)
              {
              &nbsp;
              <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="CopyToNew(instruction.instructionId)">
                Copy
              </nj-button>
              }
          </td>
          </tr>
        }
        </tbody>
      </table>
      <nj-pagination
        [count]="DataGridHelper.PageCount" 
        [shouldMinify]="true" (selectedItem)="DataGridHelper.ChangePage($event)"></nj-pagination>
    </div>
  </div>